<template>
  <div class="container">
    <div class="header" v-if="pagination.total > 0 || keyword">
      <a-input-search allowClear v-model="keyword" :placeholder="$t('createResource.search.placeholder')" @change="onSearch">
        <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
        <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, onSearch()" :src="require('@/assets/icons/icon_gb.png')" />
        <a-button class="search-btn" slot="enterButton">
          {{ $t('createResource.search.search') }}
        </a-button>
      </a-input-search>
      <a-button type="primary" @click="prelessonAdd">{{ $t('createResource.actions.new') }}</a-button>
    </div>
    <div class="list" v-if="pagination.total > 0">
      <div class="item" v-for="item in list" :key="item.key">
        <div class="cover">
          <div class="modal">
            <a-button @click="edit(item.id)">{{ $t('createResource.actions.edit') }}</a-button>
            <a-button @click="preview(item.id)">{{ $t('createResource.actions.view') }}</a-button>
            <img
              class="del"
              @click="delModal(item.id)"
              @mouseenter="delHoverStatus = true"
              @mouseleave="delHoverStatus = false"
              :src="delHoverStatus ? require('@/assets/icons/icon_kj_sc_x.png') :
                require('@/assets/icons/icon_kj_sc.png')" >
          </div>
          <img v-if="item.cover" :src="item.cover" alt="" srcset="">
          <img v-else src="https://src-glp-u-resource.growlib.com/review/2023518/116f803a5e48316775f87462d6472c1d.png" alt="" srcset="">
        </div>
        <div class="bottom">
          <a-tooltip class="name">
            <template slot="title">
              {{ item.title }}
            </template>
            {{ item.title }}
          </a-tooltip>
        </div>
      </div>
    </div>
    <div class="nodata" :class="{full: !keyword}" v-else>
      <img src="@/assets/img/bj_zanwu_2.png" v-if="keyword" alt="" srcset="">
      <img src="@/assets/img/bj_zanwu@2x.png" v-else alt="" srcset="">
      <div>
        <div>{{ $t('createResource.empty.title') }}</div>
        <a-button type="primary" v-if="!keyword" class="lesson-add" @click="prelessonAdd">
          {{ $t('createResource.actions.new') }}
        </a-button>
        <div v-else>{{ $t('createResource.empty.searchTip') }}</div>
      </div>
    </div>
    <Pagination
      class="list-pagination"
      :pagination.sync="pagination"
      @handleTableChange="handleTableChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p></p>
        <p>${$t('createResource.dialog.delete.title')}</p>
        <p class='placeholder'>${$t('createResource.dialog.delete.content')}</p>`" />
  </div>
</template>
<script>
import {
  creatorLessonDel,
  creatorLessonList
} from '@/api/lesson'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'

export default {
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      list: [],
      editId: -1,
      pagination: {
        page: 1,
        total: 0,
        pageSize: 20
      },
      keyword: undefined,
      delId: undefined,
      delVisible: false,
      delHoverStatus: false,
      replaceName: undefined
    }
  },
  methods: {
    onSearch() {
      this.pagination.page = 1
      this.getCreatorLessonList()
    },
    prelessonAdd() {
      this.$router.push({
        path: '/create/lesson/editor',
        query: {
          type: 'editor',
          isFrame: '1'
        }
      })
    },
    edit(id) {
      this.$router.push({
        path: '/create/lesson/editor',
        query: {
          type: 'editor',
          id
        }
      })
    },
    preview(id) {
      this.$router.push({
        path: '/create/lesson/editor',
        query: {
          type: 'player',
          id
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      creatorLessonDel({ id: this.delId }).then(res => {
        if (res.code == 200) {
          this.$message.success(this.$t('createResource.dialog.delete.success'))
          this.delVisible = false
          this.delId = undefined
          this.pagination.page = 1
          this.getCreatorLessonList()
        }
      })
    },
    handleTableChange() {
      this.getCreatorLessonList()
    },
    getCreatorLessonList() {
      const data = {
        keyword: this.keyword,
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      creatorLessonList(data).then(res => {
        if (res.code != 200) return
        this.list = res.data.list
        this.pagination.total = res.data.total
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getCreatorLessonList()
    })
  }
}
</script>

<style lang="less" scoped>
.container{
  position: relative;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination{
    width: 100%;
    height: auto;
    // bottom: 50px;
    position: absolute;
  }
}
h4{
  padding: 20px 28px 0 19px;
}
p{
  font-size: 12px;
  font-weight: 400;
  color: #687F9C;
  margin-bottom: 0;
  line-height: 17px;
  padding: 0 28px 0 19px;
}
.header{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 46px 28px 22px 19px;
  justify-content: space-between;
  /deep/.ant-input-group-wrapper{
    width: 330px;
    height: 35px;
    .ant-input-prefix{
      // right: auto;
      left: 16px;
      img{
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon{
        display: none;
      }
      .clear{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search{
      height: 35px;
      .ant-input{
        height: 35px;
        color: #000;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #D8DCE0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn{
      border-left: 0;
      height: 35px;
      border-color: #D8DCE0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span{
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before{
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #E9E9E9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.list{
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  padding-right: 5px;
  padding: 12px 28px 0 19px;
  max-height: calc(100% - 150px);
  .item{
    width: calc((100% - 88px) / 5);
    margin-top: 18px;
    margin-right: 22px;
    position: relative;
    display: inline-block;
    .icon-top{
      top: 6px;
      left: 0;
      width: 59px;
      height: 26px;
      position: absolute;
    }
    .cover{
      width: 100%;
      height: 164px;
      cursor: pointer;
      position: relative;
      img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .modal{
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: none;
        position: absolute;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.6);
        .del{
          top: 10px;
          right: 10px;
          width: 18px;
          height: 18px;
          position: absolute;
        }
        .ant-btn{
          border: 0;
          width: 90px;
          height: 32px;
          color: #fff;
          border-radius: 25px;
          background: #848EA1;
        }
        .ant-btn:first-child{
          margin-right: 20px;
          background: linear-gradient(245deg, #FA8D53 0%, #FF702A 100%);
        }
      }
      &:hover .modal{
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .bottom{
      display: flex;
      flex-wrap: wrap;
      cursor: pointer;
      padding: 6px 0 9px 12px;
      align-items: flex-start;
      justify-content: space-between;
      .name{
        width: 100%;
        color: #000;
        font-size: 15px;
        font-weight: 550;
        overflow: hidden;
        text-wrap: nowrap;
        margin-bottom: 2px;
        // text-align: center;
        display: inline-block;
        text-overflow: ellipsis;
        &::after{
          bottom: 0;
          left: 12px;
          content: '';
          width: 21px;
          height: 3px;
          opacity: 0.6;
          position: absolute;
          border-radius: 2px;
          background: #EF623D;
          box-shadow: 0px 0px 10px -2px rgba(133,133,133,0.66);
        }
      }
    }
    &:nth-child(-n + 5) {
      margin-top: 0;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
  }
  .item:hover{
    .bottom .name{
      color: #FF6D00 !important;
    }
  }
  /deep/.ant-btn-default,
  .ant-dropdown-trigger{
    border: 0;
    color: #000000;
    box-shadow: none;
    border: 1px solid #fff;
  }
  /deep/.ant-dropdown-trigger.ant-dropdown-open{
    color: #FF6D00;
    background: #FFEDEA;
    border: 1px solid #FF6D00;
  }
}

/deep/.ant-modal{
  .ant-modal-body{
    color: #000;
    font-size: 14px;
    span:first-child{
      color: red;
      margin-right: 6px;
    }
    .ant-input-affix-wrapper{
      // width: 300px;
      margin-top: 6px;
      .ant-input{
        color: #000;
      }
    }
  }
  .ant-modal-footer{
    text-align: center;
    .ant-btn-primary{
      margin-left: 50px;
    }
  }
}
.nodata{
  display: flex;
  position: relative;
  align-items: center;
  padding: 150px 100px;
  flex-direction: column;
  justify-content: center;
  height: calc(100% - 103px);
  img{
    width: 285px;
    // height: 300px;
    margin-bottom: 50px;
  }
  >div{
    width: 100%;
    display: flex;
    margin-top: -70px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    div{
      color: #0D2340;
      cursor: pointer;
      font-weight: 550;
      margin-left: 10px;
      font-size: 14px;
      position: relative;
      &:last-child{
        font-weight: 500;
        font-size: 12px;
      }
    }
    .lesson-add{
      cursor: pointer;
      font-weight: 500;
      margin-left: 10px;
      margin-top: 12px;
    }
  }
}
.full.nodata{
  height: 100%;
}
.item:hover{
  .bottom .left{
    color: #FF6D00 !important;
  }
}
/deep/.ant-dropdown-menu-item{
  text-align: center;
  &:hover{
    color: #FF6D00;
    background: none;
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px){
  .list{
    .item{
      .cover{
        height: 154px;
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px){
  .list{
    .item{
      .cover{
        height: 127px;
      }
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px){
  .list{
    .item{
      .cover{
        height: 127px;
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px){
  .list{
    .item{
      .cover{
        height: 112px;
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px){
  .list{
    .item{
      .cover{
        height: 107px;
      }
    }
  }
}
@media screen and (max-width: 1200px){
  .list{
    .item{
      .cover{
        height: 79px;
      }
    }
  }
}
</style>
